import React, { useState, useEffect, useRef } from 'react';
import usePortalAuth from '../../auth/usePortalAuth';
import phishcloudIcon from './logo.png';
import chromeStoreLink from './../ChromeStoreLinkGlobal.js';
import './FirstLogin.css';

const InstallationMessage = (props) => {
  const [extensionCheck, setExtensionCheck] = useState();
  const [desktopCheck, setDesktopCheck] = useState();

  const { loading, isAuthenticated, loginWithRedirect } = usePortalAuth();
  const [userBrowser, setUserBrowser] = useState();

  useEffect(() => {
    detectBrowser();
  }, [loading]);

  const showExtensionCheck = () => {
    if (extensionCheck != null) {
      return <span></span>;
    } else if (extensionCheck === null) {
      return <h4>It looks like you do not have the extension installed yet.</h4>;
    }
  };

  const showDesktopCheck = () => {
    if (desktopCheck != null) {
      return <span></span>;
    } else if (desktopCheck === null && extensionCheck != null) {
      return (
        <h4>
          It looks like you do not have the desktop application installed yet. Please{' '}
          <a href="http://files.phishcloud.io/2.0.8/PhishCloudDesktopInstaller2.0.8GPO.msi">click here</a> to download
          and install the latest version.
        </h4>
      );
    }
  };

  useInterval(() => {
    //--To be used when there is something to scan for--//
    //if (document.getElementById("PhishCloudExtensionActive") != null) {
    //    setExtensionCheck(true)
    //} else {
    //    setExtensionCheck(false)
    //}
    setExtensionCheck(document.getElementById('PhishCloudExtensionActive'));
    setDesktopCheck(document.getElementById('PhishCloudDesktopActive'));
    //console.log(extensionCheck);
  }, 5000);

  function useInterval(callback, delay) {
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    //Set up the interval.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }

  const detectBrowser = () => {
    // var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    // Firefox 1.0+
    var isFirefox = typeof InstallTrigger !== 'undefined';
    // Safari 3.0+ "[object HTMLElementConstructor]"
    // var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/ false || !!document.documentMode;
    // Edge 20+
    var isEdge = !isIE && !!window.StyleMedia;
    // Chrome 1 - 79
    var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    // Edge (based on chromium) detection
    var isEdgeChromium = isChrome && navigator.userAgent.indexOf('Edg') != -1;

    if (isChrome === true) {
      setUserBrowser('Chrome');
    } else if (isFirefox === true) {
      setUserBrowser('Firefox');
    } else if (isIE === true) {
      setUserBrowser('InternetExplorer');
    } else if (isEdge === true) {
      setUserBrowser('Edge');
    } else if (isEdgeChromium === true) {
      setUserBrowser('EdgeChromium');
    }
  };

  const reloadPage = () => {
    window.location.reload();
  };

  const extensionBasedOnBrowser = () => {
    if (userBrowser === 'Chrome') {
      return (
        <span>
          <h4>
            <a href={chromeStoreLink}>Download the extension here.</a> If you are using Edge, you can still use the
            Chrome extension! Simply follow the link and click "Add to Chrome".
          </h4>
          <h4>
            After installing the extension, <button onClick={() => reloadPage()}>click here</button>
          </h4>
        </span>
      );
    } else if (userBrowser === 'Firefox') {
      return (
        <span>
          <h4>
            <a href=" https://addons.mozilla.org/en-US/firefox/addon/phishcloud/">
              Download the Firefox extension here
            </a>
          </h4>
          <h4>
            After installing the extension, <button onClick={() => reloadPage()}>click here</button>
          </h4>
        </span>
      );
    } else {
      return <span></span>;
    }
  };

  return (
    <div>
      {!loading ? showExtensionCheck() : <span></span>}
      {!isAuthenticated && userBrowser != undefined && extensionCheck === null ? (
        extensionBasedOnBrowser()
      ) : (
        <span></span>
      )}
      <br />
      {!loading ? showDesktopCheck() : <span></span>}
    </div>
  );
};
export default InstallationMessage;
